import React from 'react';
import { useToggleFavorite } from '../../hooks/useProjects';
import type { Project } from '../../types/project';

export function StarButton({ project, testId }: { project: Project; testId?: string }) {
  const { mutate } = useToggleFavorite();
  return (
    <a className="iio-star" style={{ cursor: 'pointer' }} data-testid={testId} onClick={() => mutate({ id: project.id, favorite: !project.favorite })}>
      {project.favorite
        ? <i className="fas fa-star" title="Un-Favourite" aria-hidden="true" />
        : <i className="far fa-star" title="Make Favourite" aria-hidden="true" />
      }
    </a>
  );
}
